// Pure WELLBY-style impact estimate for a flat donation amount split across weighted allocations. 
// Reusable by any client using this methodology, not a generic "impact calculator" for every client. 

export function calculateWellbyImpact({ amountCents, allocations, isZeroDecimal = false, unitsPerUsd = 1 }) {
  // Stripe zero-decimal currencies (JPY, KRW, VND, ...) have amountCents already in the currency's base unit 
  const amount = isZeroDecimal ? amountCents : amountCents / 100

  // cost_per_wellby/cost_per_outcome below are USD-denominated unitsPerUsd (e.g. $1 USD = £0.79 GBP) converts the donor's own-currency amount to its USD equivalent first.
  const amountUsd = amount / unitsPerUsd
  let wellbys = 0
  const breakdown = []

  allocations.forEach((allocation) => {
    const allocated = amountUsd * (allocation.share_percent / 100)
    if (allocation.cost_per_wellby) wellbys += allocated / allocation.cost_per_wellby

    if (allocation.outcome_label && allocation.cost_per_outcome) {
      breakdown.push({
        name: allocation.name,
        outcomes: allocated / allocation.cost_per_outcome,
        outcomeLabel: allocation.outcome_label
      })
    }
  })

  return { wellbys, breakdown }
}